import type { PrizeData, ProgressStop } from './dailyBonusRive.types';

export const ARTBOARD_NAME = 'Main';
export const STATE_MACHINE_NAME = 'State Machine 1';

export const EMPTY_STOP: ProgressStop = { num: 0, isCurrent: false, isChecked: false };

export const EMPTY_PRIZE: PrizeData = {
  prizeType: 'DEFAULT',
  placeholderNum: '',
  coinsAmount: '',
};
